// extracted by mini-css-extract-plugin
export default {"FundoModal":"estilo_FundoModal__nleVZ","Modal":"estilo_Modal__XvVKG","ImgStatus":"estilo_ImgStatus__7bkMz","Mensagem":"estilo_Mensagem__SVHgd"};